import CreatorGroupMembership from '@/types/creatorGroupMembership';
import useBrandCreatorGroupsQuery from '@/hooks/queries/use-brand-creator-groups-query';
import useCreatorGroupsMembershipsQuery from '@/hooks/queries/use-creator-groups-memberships-query';
import useBrandId from '@/hooks/use-brand-id';
import useListCreatorsStore from '@/stores/list-creators/listCreatorsStore';

function usePreferredCreatorGroupMemberships() {
  const brandId = useBrandId();
  const {creatorGroups} = useBrandCreatorGroupsQuery({brandId});
  const creatorGroupId = creatorGroups[0]?.id ?? '';
  const selectedLists = useListCreatorsStore((state) => state.selectedLists);
  const tableFilterValue = useListCreatorsStore(
    (state) => state.tableFilterValue
  );
  const sorting = useListCreatorsStore((state) => state.sorting);

  // Query for all creators (no label filters)
  const allCreatorsQuery = useCreatorGroupsMembershipsQuery({
    creatorGroupId,
    labelIds: [],
    q: tableFilterValue,
    sorting,
  });

  // Query for filtered creators
  const membershipQueryKey = {
    creatorGroupId,
    labelIds: [...selectedLists],
    q: tableFilterValue,
    sorting,
  };

  const membershipsResponse =
    useCreatorGroupsMembershipsQuery(membershipQueryKey);

  const memberships =
    (membershipsResponse.data as CreatorGroupMembership[]) ?? [];

  return {
    memberships,
    isLoading: membershipsResponse.isLoading,
    isFetching: membershipsResponse.isFetchingNextPage,
    membershipQueryKey,
    creatorGroupId,
    fetchNextPage: membershipsResponse.fetchNextPage,
    totalGroupCreators: membershipsResponse.totalEntries,
    totalCreators: allCreatorsQuery.totalEntries,
  };
}

export default usePreferredCreatorGroupMemberships;
